import { render, staticRenderFns } from "./ddlOrder.vue?vue&type=template&id=0e0ea533&scoped=true&"
import script from "./ddlOrder.vue?vue&type=script&lang=js&"
export * from "./ddlOrder.vue?vue&type=script&lang=js&"
import style0 from "./ddlOrder.vue?vue&type=style&index=0&id=0e0ea533&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0ea533",
  null
  
)

export default component.exports